var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useCallback } from 'react';
import { apiCreateClientSeminarDocumentPageView } from '../../../actions/ClientSeminarActions';
import { wrapDispatch } from '../../action';
export const useClientSeminarSaveViewEvent = (options) => {
    const { dispatch, isShowDocumentModal, seminarId, timeout = 2000 } = options;
    const onChangeDocumentImage = useCallback((imageIndex, option) => {
        const { activeColumn } = option;
        let pageViewId = null;
        let running = false;
        let interval;
        const savePageView = () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (running) {
                return;
            }
            running = true;
            try {
                const action = apiCreateClientSeminarDocumentPageView(seminarId, imageIndex, pageViewId);
                const { payload } = yield wrapDispatch(dispatch, action);
                pageViewId = (_a = payload === null || payload === void 0 ? void 0 : payload.id) !== null && _a !== void 0 ? _a : null;
            }
            finally {
                running = false;
            }
        });
        if (isShowDocumentModal && !activeColumn) {
            savePageView().then();
            interval = setInterval(savePageView, timeout);
        }
        return () => {
            clearInterval(interval);
        };
    }, [seminarId, isShowDocumentModal, dispatch, timeout]);
    return {
        onChangeDocumentImage,
    };
};
export default useClientSeminarSaveViewEvent;
